import { render, staticRenderFns } from "./DynamicModelCustomFormShell.vue?vue&type=template&id=46a252a5&scoped=true"
import script from "./DynamicModelCustomFormShell.vue?vue&type=script&lang=js"
export * from "./DynamicModelCustomFormShell.vue?vue&type=script&lang=js"
import style0 from "./DynamicModelCustomFormShell.vue?vue&type=style&index=0&id=46a252a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a252a5",
  null
  
)

export default component.exports